import { useContext } from 'react'
import { NotificationsOutlined, PersonOutlined, SmartButtonOutlined } from '@mui/icons-material'
import { Chip, Grid, Skeleton } from '@mui/material'

import useSharedStyles from '../../../../utils/shared.styles'
import AccountsContext from '../../context'
import useStyles from '../../index.styles'

interface IProps {
  count: number
  countType: 'alertsCount' | 'devicesCount' | 'contactsCount'
  accountStatus: string
  dataTestId?: string
}

const CountChip = (props: IProps) => {
  const { count, countType, accountStatus, dataTestId } = props

  const classes = useStyles
  const sharedClasses = useSharedStyles
  const { isLoading, folderTree } = useContext(AccountsContext)
  const showChip = accountStatus !== 'Inactive' && ((countType === 'devicesCount' && count > 0) || countType !== 'devicesCount')

  let icon = <NotificationsOutlined color="inherit" fontSize="small" />
  let ariaLabel = ''
  let skeletonLabel = ''
  switch (countType) {
    case 'alertsCount':
      icon = <NotificationsOutlined color="inherit" fontSize="small" />
      ariaLabel = `${count} alerts`
      skeletonLabel = 'Loading alerts count'
      break
    case 'devicesCount':
      icon = <SmartButtonOutlined color="inherit" fontSize="small" />
      ariaLabel = `${count} devices`
      skeletonLabel = 'Loading devices count'
      break
    default: // contactsCount
      icon = <PersonOutlined color="inherit" fontSize="small" />
      ariaLabel = `${count} contacts`
      skeletonLabel = 'Loading contacts count'
      break
  }

  return folderTree && !isLoading ? (
    <>
      {showChip && (
        <Chip
          size="medium"
          label={
            <Grid container={true} sx={sharedClasses.centerContent}>
              <Grid sx={[sharedClasses.centerContentVertical, classes.chipIcon]}>{icon}</Grid>
              <Grid>{count}</Grid>
            </Grid>
          }
          sx={classes.countChip}
          aria-label={ariaLabel}
          data-testid={dataTestId}
        />
      )}
    </>
  ) : (
    <Skeleton width="48px" height="32px" aria-label={skeletonLabel} />
  )
}

export default CountChip
